import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DnList'],
});

export const dnListApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDnLists: builder.query({
      query: () => `dn_list/`,
      providesTags: ['DnList'],
    }),
    findAllDnListBySelection: builder.query({
      query: () => `dn_list/selection_data/`,
      providesTags: ['DnList'],
    }),

    findAllDnListReprintByDelivery_note_id: builder.query({
      query: (id) => `dn_list/reprint/?delivery_note_id=${id}`,
      providesTags: ['DnList'],
    }),

    findAllDnListByPagination: builder.query({
      query: (payload) => {
        let url = `dn_list/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['DnList'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindAllDnListsQuery } = dnListApi;
